module.exports = __webpack_public_path__ + "img/estilo_paso3.33758f32.svg";